const CODE_FACTURE = [
  { code: '{AA}', title: 'societes.codeGeneratorFacture.paramFacture.annee' },
  { code: '{AAAA}', title: 'societes.codeGeneratorFacture.paramFacture.anneefull' },
  { code: '{MM}', title: 'societes.codeGeneratorFacture.paramFacture.mois' },
  { code: '{SI}', title: 'societes.codeGeneratorFacture.paramFacture.nomComptable' },
  { code: '{S|}', title: 'societes.codeGeneratorFacture.paramFacture.codeSocietefull' },
  { code: '{S}', title: 'societes.codeGeneratorFacture.paramFacture.codeSociete' },
  { code: '{SS}', title: 'societes.codeGeneratorFacture.paramFacture.codeSocieteExtended' },
  { code: '{FFF}', title: 'societes.codeGeneratorFacture.paramFacture.codeRegle' },
  { code: '{FFFFF}', title: 'societes.codeGeneratorFacture.paramFacture.codeRegleExtended' },
  { code: '{F|}', title: 'societes.codeGeneratorFacture.paramFacture.codeRegleFull' },
  { code: '{CCCC}', title: 'societes.codeGeneratorFacture.paramFacture.exerciceExtended' },
  { code: '{CC}', title: 'societes.codeGeneratorFacture.paramFacture.exercice' },
  { code: '{P}', title: 'societes.codeGeneratorFacture.paramFacture.codeAgence' },
  { code: '{PP}', title: 'societes.codeGeneratorFacture.paramFacture.codeAgenceExtended' },
  { code: '{Q}', title: 'societes.codeGeneratorFacture.paramFacture.libelleAgence' },
  { code: '{QQ}', title: 'societes.codeGeneratorFacture.paramFacture.libelleAgenceExtended' },
  { code: '{SUF}', title: 'societes.codeGeneratorFacture.paramFacture.suffixeCodeFacture' },
  {
    code: '{XXXX}',
    title: 'societes.codeGeneratorFacture.paramFacture.sequence',
    subtitle: 'societes.messageInfo',
  },
];

const masques = {
  masqueCodeFacture: {
    title: 'societes.codeGeneratorFacture.title',
    codes: CODE_FACTURE,
    warningMessage: {
      title: 'societes.codeGeneratorFacture.warningMessage.title',
      content: 'societes.codeGeneratorFacture.warningMessage.content',
    },
  },
};

export default masques;
